export default "__VITE_ASSET__339dcc56__"